import React from "react";
import { Box, Container, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const LegalFooter: React.FC = () => (
  <Box
    component="footer"
    sx={{
      py: 3,
      bgcolor: "#232833",
      borderTop: "1px solid #434C5E",
    }}
  >
    <Container
      maxWidth="lg"
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1.5,
      }}
    >
      <Typography variant="body2" sx={{ color: "rgba(236,239,244,0.68)" }}>
        © {new Date().getFullYear()} Ray Jones. All rights reserved.
      </Typography>
      <Box sx={{ display: "flex", gap: 2.5 }}>
        <Link
          component={RouterLink}
          to="/terms"
          underline="hover"
          sx={{ color: "secondary.main", fontSize: "0.875rem", fontWeight: 700 }}
        >
          Terms
        </Link>
        <Link
          component={RouterLink}
          to="/privacy-policy"
          underline="hover"
          sx={{ color: "secondary.main", fontSize: "0.875rem", fontWeight: 700 }}
        >
          Privacy Policy
        </Link>
      </Box>
    </Container>
  </Box>
);

export default LegalFooter;
